import { c as _c } from "react/compiler-runtime";
import './child-bio-details.scss';
import { useRouter, useSearchParams } from 'next/navigation';
import { useCart } from '@sola/cart-sdk/store.tsx';
import type { ChildAvailabilityItem, ChildDetails } from '@sola/schema/dotcom/children/child.ts';
import { useChildSponsorship } from '../../hooks/useChildSponsorship.ts';
import { ChildBioDetailsHeading } from './child-bio-details-heading.tsx';
import { ChildBioInfo } from './child-bio-info.tsx';
import { SubmitButton } from './child-bio-sponsorship-submit-button.tsx';
import { ChildBioSummary } from './child-bio-summary.tsx';
import { ChildBioTabs } from './child-bio-tabs.tsx';
export const ChildBioDetails = t0 => {
  const $ = _c(22);
  const {
    seoLevel: t1,
    details
  } = t0;
  const seoLevel = t1 === undefined ? 1 : t1;
  useRouter();
  useSearchParams();
  useCart("actions");
  const {
    globalId
  } = details;
  const {
    isSubmitting,
    bioErrors,
    handleSponsorshipSubmit
  } = useChildSponsorship(globalId);
  let t2;
  if ($[0] !== details || $[1] !== seoLevel) {
    t2 = <ChildBioDetailsHeading seoLevel={seoLevel} details={details} />;
    $[0] = details;
    $[1] = seoLevel;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  if ($[3] !== details) {
    t3 = <ChildBioSummary details={details} />;
    t4 = <ChildBioInfo details={details} />;
    $[3] = details;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[6] !== bioErrors || $[7] !== details || $[8] !== handleSponsorshipSubmit || $[9] !== isSubmitting) {
    t5 = <SubmitButton bioErrors={bioErrors} className="mt-comfy-xl" details={details} isSubmitting={isSubmitting} handleSponsorshipSubmit={handleSponsorshipSubmit} />;
    $[6] = bioErrors;
    $[7] = details;
    $[8] = handleSponsorshipSubmit;
    $[9] = isSubmitting;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <div className="ChildBioDetails__intro">{t2}{t3}{t4}{t5}</div>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== details || $[17] !== seoLevel) {
    t7 = <div className="ChildBioDetails__content"><ChildBioTabs seoLevel={seoLevel} details={details} /></div>;
    $[16] = details;
    $[17] = seoLevel;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== t6 || $[20] !== t7) {
    t8 = <div className="ChildBioDetails body-md xl:pr-comfy-xl grid gap-roomy-sm">{t6}{t7}</div>;
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
  } else {
    t8 = $[21];
  }
  return t8;
};